export default "__VITE_ASSET__B$eqCOR8__"